import SubcategoryPage from '@/components/template/SubcategoryPage';

const Harmonija = () => {
  const products = [
    {
      title: "Harmonija Omarica",
      imageSrc: "https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80",
      url: "/pohistvo/harmonija/omarica"
    },
    {
      title: "Harmonija Polica",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/pohistvo/harmonija/polica"
    },
    {
      title: "Harmonija Ogledalo",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/pohistvo/harmonija/ogledalo"
    },
    {
      title: "Harmonija Komoda",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/pohistvo/harmonija/komoda"
    },
    {
      title: "Harmonija Stol",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/pohistvo/harmonija/stol"
    },
    {
      title: "Harmonija Set",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/pohistvo/harmonija/set"
    }
  ];

  return (
    <SubcategoryPage
      title="Kolekcija Harmonija"
      description="Odkrijte našo harmonično kolekcijo pohištva, kjer se eleganca sreča z udobjem. Naši izdelki so oblikovani za ustvarjanje mirne in uravnotežene atmosfere v vašem domu."
      heroImage="https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Harmonija;